<script>
  import { createEventDispatcher } from "svelte";
  import { searchParamsStore } from "./stores.js";

  const dispatch = createEventDispatcher();

  function updateSearch(event) {
    searchParamsStore.update(store => {
      store.text = event.target.value;
      return store;
    });
  }
</script>

<style>
  label {
    font-weight: bold;
  }

  input {
    border-radius: 6px;
    height: 30px;
    width: 100%;
    margin-bottom: 0;
  }
</style>

<div class="search-wrap">
  <label for="search">Search</label>
  <input
    on:input={event => updateSearch(event)}
    id="search"
    data-testid="subject-search"
    type="search" />
</div>
